import * as AI from 'react-icons/ai'
import * as BI from 'react-icons/bi'
import * as BS from 'react-icons/bs'
import * as CG from 'react-icons/cg'
import * as FA from 'react-icons/fa'
import * as FC from 'react-icons/fc'
import * as FI from 'react-icons/fi'
import * as GI from 'react-icons/gi'
import * as GR from 'react-icons/gr'
import * as HI from 'react-icons/hi2'
import * as IM from 'react-icons/im'
import * as IO from 'react-icons/io'
import * as IO5 from 'react-icons/io5'
import * as MD from 'react-icons/md'
import * as RI from 'react-icons/ri'
import * as SI from 'react-icons/si'

export { FA, FC, RI, BS, BI, GI, IO, GR, IM, AI, FI, CG, SI, MD, HI, IO5 }
